<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 240px; min-width: 240px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                    <template slot="description">
                      <div v-if="itemf.processNodeName === '制单人'">
                        {{ itemf.approvalTime }}
                      </div>
                      <div v-else>
                        <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                        <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                        <div>经办人：{{ itemf.maker || '' }}</div>
                        <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                        <div>时间：{{ itemf.makerTime || '' }}</div>
                      </div>
                    </template>
                  </el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo2"
                        :refObj.sync="formInfo2.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData"
                        border
                        :summary-method="getSummaries"
                        show-summary
                        max-height="430"
                        style="width: 99%;"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                        <el-table-column fixed="left"
                        type="index"
                        width="50">
                        </el-table-column>
                    <!-- <el-table-column prop="billNoMeterWayCar"
                                    align="center"
                                    label="过磅单号" width='120px'>
                    </el-table-column> -->
                    <el-table-column prop="carNo"
                                    align="center"
                                    label="车牌号" width='80px'>
                    </el-table-column>
                    <el-table-column prop="containerNumber"
                                    align="center"
                                    label="柜号" width='80px'>
                    </el-table-column>
                        <el-table-column prop="grade"
                                        label="货物品名"
                                        align="center" width='100px'>
                        </el-table-column>
                    <el-table-column prop="carNetWeight"
                                    align="center"
                                    label="到货数量" width='100px'>
                    </el-table-column>
                    <el-table-column prop="carDeductWeight"
                                    align="center"
                                    label="扣杂数量" width='60px'>
                    </el-table-column>
                    <el-table-column prop="settleQuantity"
                                    align="center"
                                    label="结算数量" width='90px'>
                    </el-table-column>
                    <el-table-column prop="settleExctTaxPrice"
                                    align="center"
                                    label="结算单价(不含税)" width="90px">
                    </el-table-column>
                    <el-table-column prop="settlePrice"
                                    align="center"
                                    label="结算单价(含税)" width="80px">
                    </el-table-column>
                        <el-table-column prop="purOrderPrice"
                                        label="订单单价"
                                        align="center" width="80px">
                        </el-table-column>
                        <el-table-column prop="evaluationPrice"
                                        label="评铁单价"
                                        align="center" width="80px">
                        </el-table-column>
                    <el-table-column prop="settleExctTaxAmount"
                                    align="center"
                                    :label="'结算金额(不含税)/'+amountUnit" width="110px">
                        <template slot-scope="scope">
                        <span>{{scope.row.settleExctTaxAmount?formatAmount(Number(scope.row.settleExctTaxAmount)):''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="settleAmount"
                                    align="center"
                                    :label="'结算金额(含税)/'+amountUnit" width="110px">
                        <template slot-scope="scope">
                        <span>{{scope.row.settleAmount?formatAmount(Number(scope.row.settleAmount)):''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="billDate"
                                    align="center"
                                    label="到货时间" width="140px">
                    </el-table-column>
                    <el-table-column prop="billNo"
                                    align="center"
                                    label="到货单号" width='120px'>
                    </el-table-column>
                    <el-table-column prop="billNoMeterWayCar" align="center" width="120px"
                                    label="过磅单号">
                    </el-table-column>
                </el-table>
                
                <!-- 审核表单 -->
                <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                   <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfoAuditData"
                             :refObj.sync="formInfoAuditData.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
        
        <!-- 采购订单对话框 -->
        <Boyo-Dialog :dialogInfo="dialogInfoProcure"
                    @dialogEvent="dialogEventProcure">
            <Boyo-Formtwo :formInfo="formInfoProcure"
                        :refObj.sync="formInfoProcure.ref"
                        :listTypeInfo='listTypeInfo'>
            </Boyo-Formtwo>
            <!-- 采购订单表格 -->
            <el-table :data="tableDataProcure"
                    border
                    max-height="430"
                    style="width: 99%;margin-top:10px;"
                    :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                    :cell-style="{padding:'2px'}">
                <el-table-column fixed="left"
                              type="index"
                              width="50">
                </el-table-column>
                <el-table-column prop="grade"
                              label="废钢级别"
                              align="center">
                </el-table-column>
                <el-table-column prop="materialNo"
                              label="物料编号"
                              align="center">
                </el-table-column>
                <el-table-column prop="materialName"
                              label="物料名称"
                              align="center">
                </el-table-column>
                <el-table-column prop="materialSpec"
                              label="物料规格"
                              align="center">
                </el-table-column>
                <el-table-column prop="baseQuantity"
                              label="订单数量"
                              align="center">
                </el-table-column>
                <el-table-column prop="unitName"
                              label="单位"
                              align="center" width="60">
                </el-table-column>
                <el-table-column prop="purExctTaxPrice"
                              label="单价"
                              align="center">
                </el-table-column>
                <el-table-column prop="purPrice"
                              label="含税单价"
                              align="center">
                </el-table-column>
                <el-table-column prop="purExctTaxMoney"
                              label="金额"
                              align="center">
                </el-table-column>
                <el-table-column prop="purMoney"
                              label="含税金额"
                              align="center">
                </el-table-column>
                <el-table-column prop="remark"
                              label="备注"
                              align="center">
                </el-table-column>
            </el-table>
        </Boyo-Dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'SettleDetailDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      createdBy: null, // 保存传入的制单人
      createdTime: null, // 保存传入的制单时间
      showAuditDataFields: false, // 是否显示审核表单
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '结算单'
        ],
        showPhraseManager: false,
        newPhrase: '',
      formInfoAuditData: {
        ref: null,
        labelWidth: '100px',
        data: {
          id:'',
          factoryAreaId:'',
          factoryAreaCode:'',
          factoryAreaName:'',
          processId:'',
          remark:'',
          status:'',
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status:[{ required: true, trigger: 'change',message: '请选择' }]
        }
      },
      // 采购订单对话框相关
      tableDataProcure: [], // 采购订单表格数据
      dialogInfoProcure: {
        visible: false, // 弹框是否显示
        width: '80%', // 宽度
        title: {
          update: "采购订单详情" // 标题
        },
        type: 'update', // 显示哪个标题
        // 按钮列表
        btList: [
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      formInfoProcure: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id:'',
          billNo: '',
          billDate: '',
          purMode: '',
          invoiceType: '',
          idMeterFactoryArea: '',
          areaName: '',
          baseAreaId: '',
          baseAreaName: '',
          contractId:'',
          partnerId:'',
          partnerName:'',
          partnerAddress:'',
          partnerPhone:'',
          partnerContacts:'',
          departureId:'',
          departureName:'',
          phone:'',
          logMenuName:'',
          logMenuCode:'',
          contractName:'',
          partnerIdNumber:'',
          partnerLegalPerson:'',
          partnerBankId:'',
          partnerBank:'',
          partnerBankAccount:'',
          partnerBankName:'',
          meterType:'',
          contractBeginDate:'',
          contractEndDate:'',
          contractDeliveryBeginDate:'',
          contractDeliveryEndDate:'',
          payeeId:'',
          payeeName:'',
          employeeId:'',
          employeeName:'',
          deliveryMode:'',
          prepaymentFlag:'',
          advanceRatio:'',
          pricingType:'',
          transportMode:'',
          totalTaxRate:'',
          totalTaxRateTwo:'',
          floatingQuantity:'',
          floatingQuantityTwo:'',
          note: '',
          businessLicense:'',
          idCardImageA:'',
          idCardImageB:'',
          bankCardImageA:'',
          bankCardImageB:'',
          video:'',
          freeItem1:'',
          freeItem2:'',
          purFlag:'',
          parentId:'',
          parentIdText:'',
        },
        list: [
          {type: "dateDay",label: "订单日期：",value: "billDate", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "select采购模式：",label: "采购模式：",value: "purMode", style: 'width:95%', className: 'form_item_two',list:'purMode',disabled:true},
          {type: "select开票类型：",label: "开票类型：",value: "invoiceType", style: 'width:95%', className: 'form_item_two',list:'invoiceType',disabled:true},
          {type: "text",label: "区域：",value: "baseAreaName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "采购合同：",value: "parentIdText", style: 'width:95%', className: 'form_item_two',showType:'0',shows:true,show:false,unclearable:true,disabled:true},
          {type: "text",label: "订单编号：",value: "businessCode", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "所属单位：",value: "areaName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "供应商：",value: "partnerName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "供应商地址：",value: "partnerAddress", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "供应联系人：",value: "partnerContacts", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "供应商电话：",value: "partnerPhone", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "供应商法人：",value: "partnerLegalPerson", style: 'width:95%', className: 'form_item_two',showType:'0',shows:true,show:false,disabled:true},
          {type: "text",label: "税号：",value: "partnerIdNumber", style: 'width:95%', className: 'form_item_two',showType:'0',shows:true,show:false,disabled:true},
          {type: "text",label: "身份证：",value: "partnerIdNumber", style: 'width:95%', className: 'form_item_two',showType:'1',shows:true,show:false,disabled:true},
          {type: 'text', label: '供应商银行：', value: 'partnerBank', style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "银行账号：",value: "partnerBankAccount", style: 'width:95%', className: 'form_item_two',showType:'1',shows:true,show:false,disabled:true},
          {type: "text",label: "账号户名：",value: "partnerBankName", style: 'width:95%', className: 'form_item_two',showType:'1',shows:true,show:false,disabled:true},
          {type: "select计量标准：",label: "计量标准：",value: "meterType", style: 'width:95%', className: 'form_item_two',list:'meterType',disabled:true},
          {type: "period2",label: "订单有效期：",value1: "contractBeginDate",value2: "contractEndDate", style: 'width:95%', className: 'form_item_two',showType:'0',shows:true,show:false,disabled:true},
          {type: "period2",label: "报柜有效期：",value1: "contractDeliveryBeginDate",value2: "contractDeliveryEndDate", style: 'width:95%', className: 'form_item_two',showType:'0',shows:true,show:false,disabled:true},
          {type: "text",label: "付款单位：",value: "payeeName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "select配送方式：",label: "配送方式：",value: "deliveryMode", style: 'width:95%', className: 'form_item_two',list:'deliveryMode',disabled:true},
          {type: "text",label: "制单人：",value: "employeeName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "select有预付款：",label: "有预付款：",value: "prepaymentFlag", style: 'width:95%', className: 'form_item_two',list:'freeItem3',disabled:true},
          {type: "number",label: "预付比例%：",value: "advanceRatio", style: 'width:95%', className: 'form_item_two',shows:true,show:false,disabled:true},
          {type: "select计价类型：",label: "计价类型：",value: "pricingType", style: 'width:95%', className: 'form_item_two',list:'pricingType',disabled:true},
          {type: "select运输方式：",label: "运输方式：",value: "transportMode", style: 'width:95%', className: 'form_item_two',list:'transportMode',showType:'1',shows:true,show:false,disabled:true},
          {type: "float",label: "税率%：",value: "totalTaxRateTwo", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "float",label: "浮动数量%：",value: "floatingQuantityTwo", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "备注：",value: "note", style: 'width:95%', className: 'form_item_two',disabled:true},
          { type: 'uploadTwo', label: '视频：', value: 'video', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[],showType:'1',shows:true,show:false,disabled:true },
          { type: 'uploadThree', label: '告知函：', value: 'freeItem1', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[] ,showType:'1',shows:true,show:false,disabled:true},
          { type: 'uploadThree', label: '订单存档：', value: 'freeItem2', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[],disabled:true },
        ],
        rules: {}
      },
      // 下拉框相关信息
      listTypeInfo: {
        purMode :[],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        processId:[],
        invoiceType:[{ value: 0, label: '正向开票' }, { value: 1, label: '反向开票' }],
        deliveryMode: [{ value: 0, label: '自提' }, { value: 1, label: '包运' }],
        meterType:[{ value: 1, label: '我方磅重' }, { value: 2, label: '对方磅重' }],
        freeItem3: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
        transportMode:[{ value: 0, label: '未确定' }, { value: 1, label: '车运' }, { value: 2, label: '船运' }, { value: 3, label: '集装箱' }],
        pricingType:[{ value: 0, label: '评铁价' }, { value: 1, label: '合同价' }],
      },
      // 表格相关
      tableInfo: {
        selection: false, // 是否显示表格单选框,
        xuhao: true,//序号显影
        selectReset: null, // 重置单选框选中
        mode: null, // 表格模板one和two两种
        data: [], // 数据
        total: 0, // 总条数
        pager: true, // 是否显示分页
        multipleSelection: [], // 表格单选框数据
        fieldList: [
          { value: "billNo",  label: "付款编号",  show: true, dropdown: true,sortable:true,fixed:'left', width: 110},
          { value: "businessType", label: "类型", show: true, dropdown: true,list:'businessType'},
          { value: "billDate",  label: "申请付款日期",  show: true, dropdown: true,sortable:true, width: 105},
          { value: 'orderBillNo',  label: '结算单号', show: true, dropdown: true, width: 105 },
          { value: 'partnerCode', label: '供应商编号', show: true, dropdown: true },
          { value: 'partnerName', label: '供应商', show: true, dropdown: true },
          { value: 'billRemark', label: '备注', show: true, dropdown: true },
          { value: "button", label: "操作", type: "slot", show: true, dropdown: true, width: 190,fixed:'right',align:'left' },
        ],
        btList: []
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id:'',
          settleNo:'',
          settleTime:'',
          purMode:'',
          partnerName:'',
          partnerCode:'',
          idCard:'',
          contractId:'',
          materialName:'',
          carNetWeight:'',
          carDeductWeight:'',
          settleQuantity:'',
          settleExctTaxPrice:'',
          settlePrice:'',
          settleExctTaxAmount:'',
          settleAmount:'',
          settleBy:'',
        },
        list: [
          { type: 'text', label: '结算单号：', value: 'settleNo', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '结算日期：', value: 'settleTime', style: 'width:80%', className: 'form_item_two',disabled:true},
          {type: "select采购模式：",label: "采购模式：",value: "purMode", style: 'width:80%', className: 'form_item_two',list:'purMode',disabled:true},
          { type: 'text', label: '供应商编号：', value: 'partnerCode', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '供应商：', value: 'partnerName', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '身份证：', value: 'idCard', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '合同编号：', value: 'contractId', style: 'width:80%', className: 'form_item_two' ,disabled:true},
          { type: 'text', label: '货物品名：', value: 'materialName', style: 'width:80%', className: 'form_item_two' ,disabled:true},
          { type: 'text', label: '到货数量：', value: 'carNetWeight', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '扣杂数量：', value: 'carDeductWeight', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '结算数量：', value: 'settleQuantity', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '不含税单价：', value: 'settleExctTaxPrice', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '含税单价：', value: 'settlePrice', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '不含税金额：', value: 'settleExctTaxAmount', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '含税金额：', value: 'settleAmount', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '制单人：', value: 'settleBy', style: 'width:80%', className: 'form_item_two',disabled:true},
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '结算单对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '对应采购订单', type: 'primary', icon: '', event: 'detailProcure', loading: false },
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
    }
  },
  created () {
  },
  mounted () {
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime){
        this.billId = data
        this.dataId = id
        // 保存传入的制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditDataFields = true
          
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfoAuditData.data) {
              this.formInfoAuditData.data[key] = ''
            }
            
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfoAuditData.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfoAuditData.data.processId = parm.processId;
              }
              
              this.formInfoAuditData.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditDataFields = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  let stepStatus = 'process';
                  if (res.data.list[i].status == 1) {
                    stepStatus = 'success';
                  } else if (res.data.list[i].status == 2) {
                    stepStatus = 'error';
                  } else {
                    stepStatus = 'process';
                  }
                  this.activeList.push({
                    processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                    maker: res.data.list[i].status
                      ? res.data.list[i].actualApprover
                      : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                    remark: res.data.list[i].remark || '', // 第三行：备注
                    makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                    stepStatus
                  });
              }
              
              // 始终在最前面插入"制单人"节点
              // 优先使用传入的制单人和时间，如果没有则尝试使用val中的数据
              let maker = this.createdBy || (val && val.createBy ? val.createBy : '暂无');
              let makerTime = this.createdTime || (val && val.createTime ? val.createTime : '');
              let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.OrderPurchase.getPurArrivalSettleNoPage({settleNo:this.billId,pageNum:1,pageSize:0,ShipStatus:5,settleFlag:1}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  this.formInfo2.data[key] = ''
                }
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                this.$api.report.getArrivalEntryListBySettleNo({settleNo:this.detailDate.settleNo,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfoAuditData.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfoAuditData.data.processId,
                    status: this.formInfoAuditData.data.status,
                    remark: this.formInfoAuditData.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                      dialogInfoData.btList[0].loading = false
                      if (res.code === 0) {
                          this.$message({ message: res.msg, type: 'success' })
                          dialogInfoData.visible = false
                          this.showAuditDataFields = false
                          this.$emit('approvalInfo')
                      } else {
                          this.$message({ message: res.msg, type: 'error' })
                      }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'detailProcure':
              this.handleDetailProcure()
              break
            case 'close':
                dialogInfoData.visible = false
                this.showAuditDataFields = false
                break
        }
    },
    
    // 处理采购订单对话框的事件
    dialogEventProcure(event){
        switch (event) {
            case 'close':
                this.dialogInfoProcure.visible = false
                break
        }
    },
    
    // 处理查看采购订单详情
    handleDetailProcure(){
        // 清空表单数据
        for (let key in this.formInfoProcure.data) {
            this.formInfoProcure.data[key] = ''
        }
        
        if(this.detailDate && this.detailDate.idPurOrder){
            this.$api.OrderPurchase.getPurOrderPage({id:this.detailDate.idPurOrder,pageNum:1,pageSize:200}).then(res2 => {
                if (res2.code === 0) {
                    if(res2.data.list.length > 0){
                        this.dialogInfoProcure.visible = true
                        for (let key in res2.data.list[0]) {
                            // 存在则赋值
                            if (key in this.formInfoProcure.data) {
                                this.formInfoProcure.data[key] = res2.data.list[0][key];
                            }
                        }
                        // 根据数据处理表单项的显示/隐藏
                        this.formInfoProcure.list.forEach(iuy=>{
                            if (iuy.label == '预付比例%：') {
                                iuy.show = false
                            }
                        })
                        if (this.formInfoProcure.data.prepaymentFlag) {
                            this.formInfoProcure.list.forEach(iuy=>{
                                if (iuy.label == '预付比例%：') {
                                    iuy.show = true
                                }
                            })
                        }
                        
                        // 处理场地字段
                        this.formInfoProcure.list.forEach(uyt=>{
                            if(uyt.label == '场地：'){
                                uyt.show = false
                            }
                        })
                        for (let inde of this.listTypeInfo.purMode) {
                            if (res2.data.list[0].purMode == inde.value) {
                                if (inde.label && inde.label.indexOf('广东场地') != -1) {
                                    this.formInfoProcure.list.forEach(uyt=>{
                                        if(uyt.label == '场地：'){
                                            uyt.show = true
                                        }
                                    })
                                }
                            }
                        }
                        
                        // 根据开票类型处理表单显示
                        if (res2.data.list[0].invoiceType == 0) {
                            this.formInfoProcure.list.forEach(uyt=>{
                                if(uyt.shows){
                                    if(uyt.label != '场地：'){
                                        uyt.show = false
                                    }
                                }
                                if((uyt.showType == '0' && uyt.label != '订单有效期：' && uyt.label != '报柜有效期：') || ((uyt.label == '订单有效期：' || uyt.label == '报柜有效期：') && this.formInfoProcure.data.purMode != 4)){
                                    uyt.show = true
                                }
                            })
                        } else if(res2.data.list[0].invoiceType == 1){
                            this.formInfoProcure.list.forEach(uyt=>{
                                if(uyt.shows){
                                    if(uyt.label != '场地：'){
                                        uyt.show = false
                                    }
                                }
                                if(uyt.showType == '1'){
                                    uyt.show = true
                                }
                            })
                        }
                        
                        // 处理特殊字段
                        this.formInfoProcure.data.totalTaxRateTwo = this.formInfoProcure.data.totalTaxRate?(Number(this.formInfoProcure.data.totalTaxRate)*100).toFixed(0):0
                        this.formInfoProcure.data.floatingQuantityTwo = this.formInfoProcure.data.floatingQuantity?(Number(this.formInfoProcure.data.floatingQuantity)*100).toFixed(0):0
                        
                        // 处理文件列表
                        if (this.formInfoProcure.list[this.formInfoProcure.list.length - 3]) {
                            this.formInfoProcure.list[this.formInfoProcure.list.length - 3].fileListHt = []
                            if (res2.data.list[0].video) {
                                this.formInfoProcure.list[this.formInfoProcure.list.length - 3].fileListHt = [{name: (res2.data.list[0].video.split('-').length > 2)?res2.data.list[0].video.split('-')[2]:res2.data.list[0].video.split('-')[1],url: res2.data.list[0].video,id: res2.data.list[0].id}]
                            }
                        }
                        if (this.formInfoProcure.list[this.formInfoProcure.list.length - 2]) {
                            this.formInfoProcure.list[this.formInfoProcure.list.length - 2].fileListHt = []
                            if (res2.data.list[0].freeItem1) {
                                this.formInfoProcure.list[this.formInfoProcure.list.length - 2].fileListHt = [{name: (res2.data.list[0].freeItem1.split('-').length > 2)?res2.data.list[0].freeItem1.split('-')[2]:res2.data.list[0].freeItem1.split('-')[1],url: res2.data.list[0].freeItem1,id: res2.data.list[0].id}]
                            }
                        }
                        if (this.formInfoProcure.list[this.formInfoProcure.list.length - 1]) {
                            this.formInfoProcure.list[this.formInfoProcure.list.length - 1].fileListHt = []
                            if (res2.data.list[0].freeItem2) {
                                this.formInfoProcure.list[this.formInfoProcure.list.length - 1].fileListHt = [{name: (res2.data.list[0].freeItem2.split('-').length > 2)?res2.data.list[0].freeItem2.split('-')[2]:res2.data.list[0].freeItem2.split('-')[1],url: res2.data.list[0].freeItem2,id: res2.data.list[0].id}]
                            }
                        }
                        
                        // 获取采购订单明细
                        this.tableDataProcure = []
                        this.$api.OrderPurchase.getPurOrderEntryPage({idPurOrder:res2.data.list[0].id,pageNum:1,pageSize:999}).then(res => {
                            if (res.code == 0) {
                                for (let i in res.data.list) {
                                    res.data.list[i].baseQuantity = res.data.list[i].purQuantity
                                    res.data.list[i].addIndex = i
                                    res.data.list[i].unitName = res.data.list[i].purUnit
                                }
                                this.tableDataProcure = res.data.list
                            } else {
                                this.$message({ message: res.msg, type: "error" });
                            }
                        })
                    } else {
                        this.$message({ message: '暂无采购订单记录', type: 'warning' })
                    }
                } else {
                    this.$message({ message: res2.msg, type: 'error' })
                }
            })
        } else {
            this.$message({ message: '没有关联的采购订单', type: 'warning' })
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    getSummaries (param) {
      //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        for(let i=0; i<100;i++){
          if(sums[i]==0){
            sums[i]=''
          }
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property === 'baseQuantity'|| column.property === 'purMoney' || column.property === 'purExctTaxMoney' || column.property === 'carNetWeight' || column.property === 'carDeductWeight' || column.property === 'settleQuantity' || column.property === 'settleExctTaxAmount' || column.property === 'settleAmount') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index]?this.formatAmount(Number(sums[index].toFixed(3))):'';
        }
      });
      this.$emit('getSummaries', sums)
      return sums;
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/SettleDetailDialog.vue